import {BasePlugin} from './BasePlugin';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

/**
 * Make the cookie consent dialog a modal. This means that the user can't interact with the rest of the page.
 */
export class DialogModal extends BasePlugin {
    options = {
    };

    destroyController = new AbortController();

    constructor(options = {}) {
        super();

        this.options = {
            ...this.options,
            ...options,
        };
    }

    initialize(cookieConsent) {
        super.initialize(cookieConsent);

        this.dialog.addEventListener('open', () => this.onDialogOpen(), {
            signal: this.destroyController.signal,
        });

        this.dialog.addEventListener('close', () => this.onDialogClose(), {
            signal: this.destroyController.signal,
        });
    }

    onDialogOpen() {
        disableBodyScroll(this.dialog);
    }

    onDialogClose() {
        enableBodyScroll(this.dialog);
    }

    destroy() {
        this.destroyController.abort();
    }
}
